import { useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule } from "ag-grid-community";
import CommonMessage from "../../common/CommonMessage";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { GetAllTransaction } from "../../services/inventory";

const modules = [AllCommunityModule];

const Tranjection = () => {
    const [allRows, setAllRows] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadTransactions();
    }, []);

    const loadTransactions = async () => {
        try {
            setLoading(true);

            const response = await GetAllTransaction();

            if (response?.success && response?.statusCode === 200) {
                setAllRows(response.data || []);
                setError("");
            } else {
                setError(response?.message || "Failed to load transactions.");
            }
        } catch (err) {
            console.log(err);
            setError(err.message || "Something went wrong.");
        } finally {
            setLoading(false);
        }
    };

    const columnDefs = useMemo(
        () => [
            {
                headerName: "ID",
                field: "id",
                width: 80,
                sortable: true,
                filter: true,
            },
            {
                headerName: "Product",
                field: "productName",
                flex: 1.5,
                sortable: true,
                filter: true,
            },
{
                headerName: "Opening Stock",
                field: "openingStock",
                flex: 1.5,
                sortable: true,
                filter: true,
            },
            {
                headerName: "Current Stock",
                field: "currentStock",
                flex: 1.5,
                sortable: true,
                filter: true,
            },
            {
                headerName: "Last Updated",
                field: "lastUpdated",
                width: 190,
                valueFormatter: (params) => {
                    if (!params.value) return "";

                    return new Date(params.value).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                    });
                },
            },
        ],
        []
    );

    const defaultColDef = useMemo(
        () => ({
            sortable: true,
            filter: true,
            floatingFilter: true,
            resizable: true,
        }),
        []
    );

    return (
        <div className="container-fluid py-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Inventory Transaction</h4>
            </div>
            {error && (
                <div className="mb-3">
                    <CommonMessage text={error} />
                </div>
            )}

            <div
                className="ag-theme-quartz"
                style={{
                    width: "100%",
                    minHeight: "500px",
                }}
            >
                <AgGridReact
                    modules={modules}
                    rowData={allRows}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    pagination={true}
                    paginationPageSize={10}
                    paginationPageSizeSelector={[10, 20, 50, 100]}
                    animateRows={true}
                    rowHeight={45}
                    domLayout="autoHeight"
                    overlayLoadingTemplate={
                        '<span class="ag-overlay-loading-center">Loading...</span>'
                    }
                    loading={loading}
                />
            </div>
        </div>
    );
};

export default Tranjection;